import {
  APP_INITIALIZER,
  ApplicationConfig,
  Injector,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  ApiConfiguration,
  ConfigurationService,
  MATERIAL_FLAG,
  WITH_CREDENTIALS_FLAG,
} from '@DataFriends-Group/ngx-core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { InactivityService } from 'src/app/service/inactivity.service';

function initializeApp(configurationSvc: ConfigurationService, injector: Injector) {
  return () => {
    configurationSvc.backend = new ApiConfiguration(
      environment.api.port ?? location.port,
      environment.api.hostname ?? location.hostname,
      environment.api.protocol ?? location.protocol,
    );

    console.log('BE address set to', configurationSvc.backend);

    // injector used so the Inactivity service is not instantiated before Configuration service
    // as there is apiUrl path built
    injector.get(InactivityService).start();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [ConfigurationService, Injector],
    },
    {
      provide: MATERIAL_FLAG,
      useValue: true,
    },
    {
      provide: WITH_CREDENTIALS_FLAG,
      useValue: false,
    },
  ],
};
